var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('question-radio-button-group',{attrs:{"questionTypes":_vm.questionTypes,"orderId":_vm.reqOrderId},on:{"selectQueType":_vm.selectQueType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }